import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * Settings → Easeedesk → Group escalation settings.
 *
 * Perechile vechi: `settings/easeedesk/group_escalation_settings` si
 * `save_group_escalation_settings`.
 *
 * `apiGet` / `apiPost` pun ELE `/api/v2` in fata caii.
 */

export interface GroupEscalationType {
  type_id: number
  type_name: string
  short_name: string
  color_identifier: string
  statuses: { ID: number; status_name: string }[]
  /** Starea aleasa acum; 0 = niciuna. */
  status: number
}

export interface GroupEscalationPage {
  title: string
  moduleUrl: string
  ticket_types: GroupEscalationType[]
}

export function groupEscalationQuery() {
  return queryOptions({
    queryKey: ['settings', 'easeedesk', 'group_escalation_settings'],
    queryFn: () => apiGet<GroupEscalationPage>('/settings/easeedesk/group_escalation_settings'),
  })
}

export function saveGroupEscalation(ticket_type: number, status: number) {
  return apiPost<{ ok?: boolean; status?: number }>('/settings/easeedesk/group_escalation_settings', {
    ticket_type,
    status,
  })
}
